import App from 'App';
import ReactDOM from 'react-dom/client';

import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(App);
